var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6066 22.527C15.6256 22.3362 15.9037 22.3362 15.9227 22.527V22.527C15.9335 22.6351 16.0471 22.7007 16.1461 22.656V22.656C16.3209 22.5771 16.4599 22.8179 16.3042 22.9298V22.9298C16.216 22.9932 16.216 23.1245 16.3042 23.1878V23.1878C16.4599 23.2997 16.3209 23.5405 16.1461 23.4616V23.4616C16.0471 23.4169 15.9335 23.4825 15.9227 23.5906V23.5906C15.9037 23.7814 15.6256 23.7814 15.6066 23.5906V23.5906C15.5958 23.4825 15.4821 23.4169 15.3831 23.4616V23.4616C15.2084 23.5405 15.0693 23.2997 15.225 23.1878V23.1878C15.3133 23.1245 15.3133 22.9932 15.225 22.9298V22.9298C15.0693 22.8179 15.2084 22.5771 15.3831 22.656V22.656C15.4821 22.7007 15.5958 22.6351 15.6066 22.527V22.527Z",
    fill: "url(#paint0_linear_10214_692)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0773 22.527C20.0963 22.3362 20.3744 22.3362 20.3934 22.527V22.527C20.4042 22.6351 20.5178 22.7007 20.6168 22.656V22.656C20.7916 22.5771 20.9306 22.8179 20.7749 22.9298V22.9298C20.6867 22.9932 20.6867 23.1245 20.7749 23.1878V23.1878C20.9306 23.2997 20.7916 23.5405 20.6168 23.4616V23.4616C20.5178 23.4169 20.4042 23.4825 20.3934 23.5906V23.5906C20.3744 23.7814 20.0963 23.7814 20.0773 23.5906V23.5906C20.0665 23.4825 19.9528 23.4169 19.8538 23.4616V23.4616C19.6791 23.5405 19.54 23.2997 19.6957 23.1878V23.1878C19.784 23.1245 19.784 22.9932 19.6957 22.9298V22.9298C19.54 22.8179 19.6791 22.5771 19.8538 22.656V22.656C19.9528 22.7007 20.0665 22.6351 20.0773 22.527V22.527Z",
    fill: "url(#paint1_linear_10214_692)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8419 24.527C17.8609 24.3362 18.139 24.3362 18.158 24.527V24.527C18.1688 24.6351 18.2825 24.7007 18.3815 24.656V24.656C18.5562 24.5771 18.6953 24.8179 18.5396 24.9298V24.9298C18.4513 24.9932 18.4513 25.1245 18.5396 25.1878V25.1878C18.6953 25.2997 18.5562 25.5405 18.3815 25.4616V25.4616C18.2825 25.4169 18.1688 25.4825 18.158 25.5906V25.5906C18.139 25.7814 17.8609 25.7814 17.8419 25.5906V25.5906C17.8311 25.4825 17.7175 25.4169 17.6184 25.4616V25.4616C17.4437 25.5405 17.3047 25.2997 17.4604 25.1878V25.1878C17.5486 25.1245 17.5486 24.9932 17.4604 24.9298V24.9298C17.3047 24.8179 17.4437 24.5771 17.6184 24.656V24.656C17.7175 24.7007 17.8311 24.6351 17.8419 24.527V24.527Z",
    fill: "url(#paint2_linear_10214_692)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8419 20.4094C17.8609 20.2186 18.139 20.2186 18.158 20.4094V20.4094C18.1688 20.5175 18.2825 20.5831 18.3815 20.5384V20.5384C18.5562 20.4595 18.6953 20.7003 18.5396 20.8122V20.8122C18.4513 20.8755 18.4513 21.0068 18.5396 21.0702V21.0702C18.6953 21.1821 18.5562 21.4229 18.3815 21.344V21.344C18.2825 21.2993 18.1688 21.3649 18.158 21.473V21.473C18.139 21.6638 17.8609 21.6638 17.8419 21.473V21.473C17.8311 21.3649 17.7175 21.2993 17.6184 21.344V21.344C17.4437 21.4229 17.3047 21.1821 17.4604 21.0702V21.0702C17.5486 21.0068 17.5486 20.8755 17.4604 20.8122V20.8122C17.3047 20.7003 17.4437 20.4595 17.6184 20.5384V20.5384C17.7175 20.5831 17.8311 20.5175 17.8419 20.4094V20.4094Z",
    fill: "url(#paint3_linear_10214_692)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3126 24.527C22.3316 24.3362 22.6097 24.3362 22.6287 24.527V24.527C22.6395 24.6351 22.7532 24.7007 22.8522 24.656V24.656C23.0269 24.5771 23.166 24.8179 23.0103 24.9298V24.9298C22.922 24.9932 22.922 25.1245 23.0103 25.1878V25.1878C23.166 25.2997 23.0269 25.5405 22.8522 25.4616V25.4616C22.7532 25.4169 22.6395 25.4825 22.6287 25.5906V25.5906C22.6097 25.7814 22.3316 25.7814 22.3126 25.5906V25.5906C22.3018 25.4825 22.1882 25.4169 22.0891 25.4616V25.4616C21.9144 25.5405 21.7754 25.2997 21.9311 25.1878V25.1878C22.0193 25.1245 22.0193 24.9932 21.9311 24.9298V24.9298C21.7754 24.8179 21.9144 24.5771 22.0891 24.656V24.656C22.1882 24.7007 22.3018 24.6351 22.3126 24.527V24.527Z",
    fill: "url(#paint4_linear_10214_692)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3126 20.4094C22.3316 20.2186 22.6097 20.2186 22.6287 20.4094V20.4094C22.6395 20.5175 22.7532 20.5831 22.8522 20.5384V20.5384C23.0269 20.4595 23.166 20.7003 23.0103 20.8122V20.8122C22.922 20.8755 22.922 21.0068 23.0103 21.0702V21.0702C23.166 21.1821 23.0269 21.4229 22.8522 21.344V21.344C22.7532 21.2993 22.6395 21.3649 22.6287 21.473V21.473C22.6097 21.6638 22.3316 21.6638 22.3126 21.473V21.473C22.3018 21.3649 22.1882 21.2993 22.0891 21.344V21.344C21.9144 21.4229 21.7754 21.1821 21.9311 21.0702V21.0702C22.0193 21.0068 22.0193 20.8755 21.9311 20.8122V20.8122C21.7754 20.7003 21.9144 20.4595 22.0891 20.5384V20.5384C22.1882 20.5831 22.3018 20.5175 22.3126 20.4094V20.4094Z",
    fill: "url(#paint5_linear_10214_692)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3714 24.527C13.3905 24.3362 13.6686 24.3362 13.6876 24.527V24.527C13.6984 24.6351 13.812 24.7007 13.911 24.656V24.656C14.0858 24.5771 14.2248 24.8179 14.0691 24.9298V24.9298C13.9809 24.9932 13.9809 25.1245 14.0691 25.1878V25.1878C14.2248 25.2997 14.0858 25.5405 13.911 25.4616V25.4616C13.812 25.4169 13.6984 25.4825 13.6876 25.5906V25.5906C13.6686 25.7814 13.3905 25.7814 13.3714 25.5906V25.5906C13.3607 25.4825 13.247 25.4169 13.148 25.4616V25.4616C12.9732 25.5405 12.8342 25.2997 12.9899 25.1878V25.1878C13.0781 25.1245 13.0781 24.9932 12.9899 24.9298V24.9298C12.8342 24.8179 12.9732 24.5771 13.148 24.656V24.656C13.247 24.7007 13.3607 24.6351 13.3714 24.527V24.527Z",
    fill: "url(#paint6_linear_10214_692)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3714 20.4094C13.3905 20.2186 13.6686 20.2186 13.6876 20.4094V20.4094C13.6984 20.5175 13.812 20.5831 13.911 20.5384V20.5384C14.0858 20.4595 14.2248 20.7003 14.0691 20.8122V20.8122C13.9809 20.8755 13.9809 21.0068 14.0691 21.0702V21.0702C14.2248 21.1821 14.0858 21.4229 13.911 21.344V21.344C13.812 21.2993 13.6984 21.3649 13.6876 21.473V21.473C13.6686 21.6638 13.3905 21.6638 13.3714 21.473V21.473C13.3607 21.3649 13.247 21.2993 13.148 21.344V21.344C12.9732 21.4229 12.8342 21.1821 12.9899 21.0702V21.0702C13.0781 21.0068 13.0781 20.8755 12.9899 20.8122V20.8122C12.8342 20.7003 12.9732 20.4595 13.148 20.5384V20.5384C13.247 20.5831 13.3607 20.5175 13.3714 20.4094V20.4094Z",
    fill: "url(#paint7_linear_10214_692)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.6125H10.186C7.60386 22.6125 6.11768 20.9603 6.11768 18.9178C6.11768 17.1493 7.23854 15.7545 8.89909 15.2812C9.18969 11.9684 11.913 9.4693 15.1344 9.4693C17.6004 9.4693 19.6262 10.806 20.7305 12.998C23.7444 12.998 25.9612 15.057 25.9612 17.7886C25.9612 20.4953 23.7942 22.6125 20.9962 22.6125Z",
    fill: "url(#paint8_linear_10214_692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1723 13.2792L20.3455 13.623H20.7305C23.4495 13.623 25.3362 15.4504 25.3362 17.7886C25.3362 20.1343 23.4651 21.9875 20.9962 21.9875H10.186C9.03131 21.9875 8.17783 21.6207 7.61699 21.0808C7.05544 20.5403 6.74268 19.7841 6.74268 18.9178C6.74268 17.4421 7.6651 16.2828 9.07039 15.8823L9.48411 15.7644L9.5217 15.3358C9.7846 12.3387 12.2441 10.0943 15.1344 10.0943C17.3488 10.0943 19.1671 11.2838 20.1723 13.2792Z",
    stroke: "url(#paint9_linear_10214_692)",
    strokeOpacity: 0.3,
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_692",
    x: -13.8823,
    y: -10.5307,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_692",
    x1: 14.8687,
    y1: 21.8676,
    x2: 18.1184,
    y2: 22.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_692",
    x1: 19.3394,
    y1: 21.8676,
    x2: 22.5891,
    y2: 22.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_692",
    x1: 17.104,
    y1: 23.8676,
    x2: 20.3537,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10214_692",
    x1: 17.104,
    y1: 19.75,
    x2: 20.3537,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10214_692",
    x1: 21.5747,
    y1: 23.8676,
    x2: 24.8244,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10214_692",
    x1: 21.5747,
    y1: 19.75,
    x2: 24.8244,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10214_692",
    x1: 12.6336,
    y1: 23.8676,
    x2: 15.8833,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10214_692",
    x1: 12.6336,
    y1: 19.75,
    x2: 15.8833,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10214_692",
    x1: 24,
    y1: 20.5,
    x2: 7,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10214_692",
    x1: 9.5,
    y1: 16,
    x2: 16.0394,
    y2: 22.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13N);
export default __webpack_public_path__ + "static/media/13n.f93978de96e0d9abb43a82cada9c9c72.svg";
export { ForwardRef as ReactComponent };